export const SET_COLOR_SCALES_COLUMNS = 'SET_COLOR_SCALES_COLUMNS';
export const SET_COLOR_SCALES_ALL_COLUMNS = 'SET_COLOR_SCALES_ALL_COLUMNS';
export const SET_COLUMNS = 'SET_COLUMNS';
export const REORDER_COLUMNS = 'REORDER_COLUMNS';
export const COLLAPSE_COLUMNS = 'COLLAPSE_COLUMNS';
export const TOGGLE_COLUMN_PERCENTAGE = 'TOGGLE_COLUMN_PERCENTAGE';
const ACTIONS = 'actions';

export function columnReducer(state, action) {
  switch (action.type) {
    case SET_COLUMNS: {
      const order = action.payload.order;
      const collapsed = action.payload.collapsed;
      const percentage = action.payload.percentage;
      const newColumns = order.filter((c) => !state.order.includes(c));
      const scaled = getSafeColumns(state.scaled, order);

      return {
        ...state,
        ...(state.isAllScaled
          ? {
              scaled: [...scaled, ...newColumns],
            }
          : {
              scaled: scaled, // keep prev scaled
            }),
        order,
        collapsed: getSafeColumns(state.collapsed, collapsed),
        percentage: getSafeColumns(state.percentage, percentage),
      };
    }

    case TOGGLE_COLUMN_PERCENTAGE: {
      const columnName = action.payload;
      const presented = state.percentage.includes(columnName);
      return {
        ...state,
        percentage: presented
          ? state.percentage.filter((c) => c !== columnName)
          : [...state.percentage, columnName],
      };
    }

    case REORDER_COLUMNS: {
      const order = action.payload; // todo: move collapse to separate action
      const hiddenMetricOnDimension = state.order.filter(
        (name) => !order.includes(name)
      );

      const newOrder = [
        ...order.filter((name) => name !== ACTIONS),
        ...hiddenMetricOnDimension,
      ];

      return {
        ...state,
        order: newOrder,
      };
    }

    case SET_COLOR_SCALES_COLUMNS: {
      let { isColorScale, columnName } = action.payload;
      let scaled = state.scaled;
      if (isColorScale) {
        scaled = scaled.filter((col) => col !== columnName);
      } else {
        scaled = [...scaled, columnName];
      }

      return {
        ...state,
        scaled,
      };
    }

    case COLLAPSE_COLUMNS: {
      return {
        ...state,
        collapsed: action.payload,
      };
    }

    case SET_COLOR_SCALES_ALL_COLUMNS: {
      const isAllScaled = action.payload;
      return {
        ...state,
        scaled: isAllScaled ? state.order : [],
        isAllScaled,
      };
    }
  }
}

function getSafeColumns(columns, order) {
  return columns.filter((c) => order.includes(c));
}
